import { render, staticRenderFns } from "./Karin-setting.vue?vue&type=template&id=ac34a11c&scoped=true"
import script from "./Karin-setting.vue?vue&type=script&lang=js"
export * from "./Karin-setting.vue?vue&type=script&lang=js"
import style0 from "./Karin-setting.vue?vue&type=style&index=0&id=ac34a11c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac34a11c",
  null
  
)

export default component.exports